import styled from 'styled-components';

export const DescriptionsVerticalWrapper = styled.div`
	th.ant-descriptions-item-label {
		padding-top: 12px !important;
		padding-bottom: 12px !important;
		padding-left: 0px !important;
	}
	.ant-descriptions-view {
		padding: 0px 20px !important;
	}
`;

// zera o padding/bg do <td> da linha expandida p/ o box do limite ocupar a largura toda;
// e tira o border-radius do box (arredondado sobraria nos cantos vs. as linhas quadradas)
export const PermissionsTableWrapper = styled.div`
	.ant-table-expanded-row > .ant-table-cell {
		padding: 0 !important;
		background: transparent !important;
	}
	.ant-table-expanded-row > .ant-table-cell > div {
		border-radius: 0 !important;
	}
`;
